export const cleanContent = (text: string | null | undefined): string => {
  if (!text) {
    return '';
  }

  let cleanedText = text;

  // NUOVO: Rimuovi l'entità HTML &amp;
  cleanedText = cleanedText.replace(/&amp;/g, '');

  // 1. Rimuovi i titoli Markdown (es. "## Titolo ")
  cleanedText = cleanedText.replace(/^#+\s*/gm, '');

  // 2. Rimuovi la sintassi delle tabelle Markdown (| e ---)
  // Rimuovi linee con soli separatori di tabella (es. |-------|)
  cleanedText = cleanedText.replace(/^\|-+\|(?:\s*\|-+\|)*\s*$/gm, '');
  // Rimuovi linee che contengono solo trattini e opzionalmente spazi
  cleanedText = cleanedText.replace(/^-+\s*$/gm, '');
  // Rimuovi i caratteri '|' usati nelle tabelle
  cleanedText = cleanedText.replace(/\|/g, '');

  // 3. Rimuovi la sintassi di grassetto/corsivo di Markdown (es. **, *, _, __)
  cleanedText = cleanedText.replace(/(\*\*|__|\*|_)(.*?)\1/g, '$2');

  // 4. Normalizza gli spazi bianchi:
  //    Sostituisci tab, newline e carriage return con un singolo spazio
  cleanedText = cleanedText.replace(/[\n\t\r]+/g, ' ');
  //    Sostituisci spazi multipli con un singolo spazio
  cleanedText = cleanedText.replace(/\s{2,}/g, ' ');
  //    Rimuovi spazi all'inizio e alla fine della stringa
  cleanedText = cleanedText.trim();

  return cleanedText;
};